import { data } from 'jquery';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { Paginator } from 'primeng/paginator';
import { tap } from 'rxjs/operators';


declare const $: any;
@Injectable({
  providedIn: 'root',
})
export class SearchService {
  pagesize = 10;
  level1: any;
  level2: any;
  static selectedType = 'impa'; // impa / customized
  //SearchService.selectedType
  baseUrl = environment.cloudUrl;
  qparam: string;

  searchOption = [];
  // public postsData: Post[];

  elasticIMPAUrl = this.baseUrl + 'catalogue/search';
  elasticPostUrl = this.baseUrl + 'catalogue/custom/search';
  advertisementUrl = this.baseUrl + 'advertisement/active';
  impaListUrl: string = this.baseUrl + 'catalogue/data';
  recycleUrl: string = this.baseUrl + 'catalogue/sync/impa';
  searchUrl: string = this.baseUrl + 'catalogue/search';
  customListUrl: string = this.baseUrl + 'custom/catalogue';
  synccall: string = this.baseUrl + 'catalogue/get/syncData';
  syncstatus: string = this.baseUrl + 'catalogue/sync/status';
  pictureLink:string =this.baseUrl + 'catalogue/impa/image/ById';
  currentTime: string;  


  constructor(private http: HttpClient) {
    this.getCurrentTime()
   }

  async searchResult(
    searchkey: string,
    pageNo: number,
    level1: any,
    level2: any,
    level3: any,
    filter: boolean = false,
    Paginaton: boolean = true
  ): Promise<any> {
    // searchkey = searchkey.trim();
    // this.qparam = HeaderComponent.value;
    let qparam = $('[name=search]').val();
    // console.log(this.qparam, 'param');
    let apiUrl =
      SearchService.selectedType == 'impa'
        ? this.elasticIMPAUrl
        : this.elasticPostUrl;
    apiUrl +=
      '?pageSize=' +
      this.pagesize +
      '&pageNo=' +
      pageNo +
      '&pagination=' +
      Paginaton;

    if (filter) {
      apiUrl += '&filter=' + filter;
    }

    if (searchkey) {
      apiUrl += '&q=' + encodeURIComponent(searchkey);
    }

    if (level1) {
      apiUrl += '&level1=' + encodeURIComponent(level1);
    }

    if (level2) {
      apiUrl += '&level2=' + encodeURIComponent(level2);
    }

    if (level3) {
      apiUrl += '&level3=' + encodeURIComponent(level3);
    }

    console.log(apiUrl);
    return await this.http.get(apiUrl).toPromise();
  }

  getAdvertisement(): Observable<any> {
    const url = this.advertisementUrl;
    return this.http.get(url).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getCurrentTime() {
    let currentDate = new Date();
    this.currentTime = currentDate.getHours().toString() + currentDate.getMinutes().toString() + currentDate.getSeconds().toString() + currentDate.getMilliseconds().toString();
  }

  getthePictureLink(val:any) :Observable<Blob>{
    
    console.log(val)
    const url =this.pictureLink
    // return this.http.get(url + '/' + val + '?' + this.currentTime, { responseType: 'blob' });

    return this.http.get(url + '/' + val+'?'+this.currentTime).pipe(
      map((response: any) => {
        
        return response;
        // if (response.status === 1 && response.data && response.data.type === 'Buffer' && response.data.data instanceof Array) {
        //   var uint8Array = new Uint8Array(response.data.data);     
        //   var buffer = uint8Array.buffer;
        //   var base64String = this.arrayBufferToBase64(buffer);
        //   return base64String;
        // }
      })
    );
  }


 arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }



  //  get details
  getImpaList(pageNo: any): Observable<any> {
    const url = this.impaListUrl;
    return this.http.get(url + '/' + pageNo).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getSyncList(): Observable<any> {
    const url = this.recycleUrl;
    return this.http.get(url).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getSearchList(pageNo: any, val: any): Observable<any> {
    const url = this.searchUrl;
    return this.http
      .get(url + '?pageNo=' + pageNo + '&pagination=true&q=' + val)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getCustomList(): Observable<any> {
    const url = this.customListUrl;
    return this.http.get(url).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getSynAfter(): Observable<any> {
    const url = this.syncstatus;
    return this.http.get(url).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
